<template>
  <v-btn icon v-on:click="dialog = true" density="compact" color="green">
    <v-icon :icon="['fas', 'filter']" />
    <v-tooltip activator="parent" location="bottom">
      Фильтры
    </v-tooltip>
  </v-btn>

  <v-dialog style="backdrop-filter: blur(1px)" scrollable v-model="dialog" fullscreen persistent>
    <template v-slot:default>
      <v-card rounded="0">
        <template v-slot:title>
          <p class="font-weight-bold">ФИЛЬТРЫ</p>
        </template>
        <template v-slot:append>
          <v-btn rounded="0" v-on:click="clear_filters()" flat color="green" class="border-b-sm" variant="tonal" height="40">
            ОЧИСТИТЬ ФИЛЬТРЫ
          </v-btn>
          <v-text-field width="300" v-model="search" label="ПОИСК" hide-details rounded="0" variant="filled" density="compact" flat color="black">
            <template v-slot:append-inner>
              <v-icon :icon="['fas', 'magnifying-glass']" />
            </template>
          </v-text-field>
          <v-btn rounded="0" v-on:click="dialog = false" flat color="red" class="border-b-sm" variant="tonal" height="40">
            ЗАКРЫТЬ
          </v-btn>
        </template>
        <template v-slot:text>
          <v-sheet class="d-flex justify-start align-start" color="transparent" v-if="loaded">
            <template v-for="filter in filters" :key="filter">
              <v-sheet width="300" color="transparent" v-if="filter.list && filter.list.length > 0">
                <p class="font-weight-bold text-center">{{ filter.name }}</p>
                <v-divider />
                <template v-if="filter.type === 'Array'">
                  <template v-for="item in filter.list" :key="item">
                    <template v-if="item.guid">
                      <v-checkbox
                          v-if="search ? item.name.toLowerCase().includes(search.toLowerCase()) : true"
                          width="100%" :disabled="filter.disabled" :value="item.guid"
                          v-model="filter.selected" :base-color="item.guid === item.name ? 'amber-darken-4' : ''"
                          :label="item.name" hide-details
                      />
                    </template>
                  </template>
                </template>
              </v-sheet>
            </template>
          </v-sheet>
          <Loader v-else />
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { FiltersBlock } from "@/store/wp_planner/filters.store";
import Loader from "@/components/Different/Loader.vue";

export default {
  name: "Filter__WP_Dialog",
  components: {Loader},
  async beforeMount() {
    await this.get_filters_list()
  },
  watch: {
    dialog() {
      this.search = null
    },
    async district_guid() {
      await this.get_filters_list()
    },
    async selection_count(oldValue, newValue) {
      if (oldValue !== newValue) {
        await this.get_filters_list()
      }
    }
  },
  data() {
    return {
      search: null,
      loaded: false,
      panels: null,
      dialog: false
    }
  },
  methods: {
    clear_filters: function () {
      this.filters = null
    },
    get_filters_list: async function () {
      this.loaded = false
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/wp/filters/all`
      let raw_data = {
        "district": this.$route.params.district
      }
      if (this.filters) {
        for (let filter of this.filters) {
          if (filter && filter.selected) {
            if (filter.selected.length > 0 || filter.selected === true) {
              raw_data[filter.id] = filter.selected
            }
          }
        }
      }
      raw_data = JSON.stringify(raw_data)
      let meta = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: raw_data
      }
      fetch(url, meta)
          .then(response => response.json())
          .then(data => {
            if (data) {
              this.loaded = true
              this.filters = data
            }
          })
          .catch(err => {
            console.error(err)
          })
    }
  },
  computed: {
    selection_count() {
      let count = 0
      if (this.filters) {
        for (let filter of this.filters) {
          if (filter.selected) {
            if (filter.selected.length > 0) {
              count += filter.selected.length
            } else if (filter.selected === true) {
              count++
            }
          }
        }
      }
      return count
    },
    filters: {
      get() {
        return FiltersBlock().get()
      },
      set(value) {
        FiltersBlock().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  }
}
</script>

<style scoped>

</style>
